/* eslint-disable */
import Constants from 'client/util/Constants';
import Util from 'client/util/Util';

const embedId = 'zep64tc7uwzk';

// After an update to the widget and script from drift (Jan 2021)
// drift.load must be called twice when loading the script from thirdparty.jumpcloud.com
export function driftLoad(attributes) {
  const { drift, driftLoadCalled } = window;
  try {
    if (drift && !drift.ready && !driftLoadCalled) {
      window.driftLoadCalled = true;
      drift.reset();
      drift.identify(attributes.email, attributes);
      drift.load(embedId);
    }
  } catch (e) {
    // do nothing, catch and move on
  }
}

export default function driftScript() {

  const environments = {
    [Constants.environments.local]: 'stg',
    [Constants.environments.staging]: 'stg',
    [Constants.environments.production]: 'prd',
  };

  const env = environments[Util.getEnvironment()] || 'prd';
  const src = `https://thirdparty.jumpcloud.com/js/drift-${env}.min.js`;

  const script = document.createElement('script');
  script.src = `/include/jumpcloud/${embedId}.js`;
  script.charset = 'utf-8';
  document.body.appendChild(script);

  !function() {
    var t = window.driftt = window.drift = window.driftt || [];
    if (!t.init) {
      if (t.invoked) return void (window.console && console.error && console.error("Drift snippet included twice."));
      t.invoked = !0, t.methods = [ "identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on" ],
      t.factory = function(e) {
        return function() {
          var n = Array.prototype.slice.call(arguments);
          return n.unshift(e), t.push(n), t;
        };
      }, t.methods.forEach(function(e) {
        t[e] = t.factory(e);
      }), t.load = function(t) {
        var e = 3e5, n = Math.ceil(new Date() / e) * e, o = document.createElement("script");
        // The original, direct load of the scrpt is commented here for reference
        // o.type = "text/javascript", o.async = !0, o.crossorigin = "anonymous", o.src = "https://js.driftt.com/include/" + n + "/" + t + ".js";
        // The drift script is loaded through thirdparty.jumpcloud.com
        o.type = "text/javascript", o.async = !0, o.crossorigin = "anonymous", o.src = src;

        var i = document.getElementsByTagName("script")[0];

        i.parentNode.insertBefore(o, i);
      };
    }
  }();

  drift.SNIPPET_VERSION = '0.3.1';
  drift.load(embedId);
};
